import { api } from '../api';

type PingResponse = string;

const ping = async () => api.post<PingResponse>('/heartbeat.ping');

export default ping;
